export const FRIENDLY_SELLER_GIF_PATH =
    'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/14bf7fe3f3f3d9c66538134f0fa628b3-1651418416382/Friendly-Seller-49-alpha.gif';
export const SOURCE_COMPONENT = 'recommendation_ftb_friendly';
export const BASE_KEY = 'search_perseus.recommendations.ftb_friendly';
